export function SvelteLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      fill="none"
      viewBox="0 0 40 40"
      id="svelte"
    >
      <path
        fill="#FF3E00"
        fill-rule="evenodd"
        d="M26.113 10.7079C25.2106 9.31835 23.3526 8.92342 21.9631 9.82581L14.415 14.7276C13.0255 15.6299 12.6306 17.4879 13.533 18.8775C14.4353 20.267 16.2933 20.662 17.6829 19.7596L20.8768 17.6854C20.9209 17.6568 20.9664 17.6321 21.0129 17.6112C23.2901 16.345 26.1913 17.0425 27.6317 19.2605C29.1357 21.5765 28.4775 24.6731 26.1616 26.1771L18.6135 31.0788C16.2976 32.5828 13.201 31.9246 11.697 29.6087C10.671 28.0288 10.6524 26.0865 11.4756 24.5366C11.7347 24.0488 12.3401 23.8634 12.8278 24.1225C13.3156 24.3816 13.501 24.987 13.2419 25.4747C12.7458 26.4089 12.7599 27.5732 13.3743 28.5194C14.2767 29.909 16.1347 30.3039 17.5243 29.4015L25.0723 24.4998C26.4618 23.5974 26.8568 21.7394 25.9544 20.3498C25.052 18.9603 23.194 18.5653 21.8045 19.4677L18.7722 21.4369C16.4562 22.9409 13.3596 22.2827 11.8556 19.9668C10.3516 17.6508 11.0098 14.5542 13.3258 13.0502L20.8738 8.14847C23.1897 6.64449 26.2864 7.3027 27.7904 9.61862C28.4887 10.694 28.7209 11.9402 28.537 13.1143C28.4515 13.66 27.9399 14.033 27.3943 13.9475C26.8487 13.862 26.4756 13.3504 26.5611 12.8048C26.6717 12.0989 26.5326 11.354 26.113 10.7079Z"
        clip-rule="evenodd"
      ></path>
    </svg>
  );
}
